module.exports = __webpack_public_path__ + "img/antenna_color.5b3f4db9.svg";